import { Badge, Tabs, Skeleton } from 'antd';
import Layout, { Content } from 'antd/lib/layout/layout';
import Sider from 'antd/lib/layout/Sider';
import './ChatBot.scss';
import SquareLists from 'assets/square-list.svg';
import React, { useEffect } from 'react';
import Conversations from './Conversations/Conversations';
import Bookmarks from './Bookmarks/Bookmarks';
import QuickCheckReports from './QuickCheckReports/QuickCheckReports';
import SideNavigation from './SideNavigation/SideNavigation';
import SquareList from 'assets/SquereList.svg';
import { useChatState } from './state/chatState';

import DealHeader from './DealHeader/DealHeader';

import DeleteDialog from './DeleteDialog/DeleteDialog';
import RenameDialog from './RenameDialog/RenameDialog';
import { CloseCircleFilled, FileTextFilled } from '@ant-design/icons';
import { Button } from 'antd';
import { Mode } from './state/chatState';
import juggernaut from 'assets/juggernaut.svg';
import Canvas from 'components/ChatBot/Canvas/Canvas';
import moment from 'moment';

interface ChatBotProps {
  mode: Mode;
}
const ChatBot: React.FC<ChatBotProps> = ({ mode }) => {
  const { state, setActiveKey, loadInitialSession, setIsDocumentMode, handleNewConversation, setPromptMode } =
    useChatState();
  const { activeKey, bookmarks, currentSessionId, projects, isLoading, isDocumentMode } = state;
  const { isMessageLoading } = isLoading;

  // const getProjectIndex = () => {
  //   return projects.DEAL.findIndex((project) => project.id === currentSessionId?.project?.id);
  // };

  const handleExitWriteMode = () => {
    setIsDocumentMode(false);
    setPromptMode('Ask');
  };
  // Load initial session and messages
  useEffect(() => {
    loadInitialSession();
    setPromptMode('Ask');
    setIsDocumentMode(false);
  }, []);

  // const items = [
  //   {
  //     key: '1',
  //     label: (
  //       <span data-testid="conversationsTab" className="flex items-center space-x-1">
  //         <img src={SquareLists} alt="Conversations" className="w-[18px] h-[18px] mr-1 " />
  //         Conversations
  //       </span>
  //     ),
  //     //if document mode then show editor pane else conversation

  //     children: mode === 'document' ? <Canvas /> : <Conversations data-testid="conversations" mode={mode} />
  //   },
  //   {
  //     key: '2',
  //     label: (
  //       <span data-testid="bookmarksTab" className="flex items-center space-x-1">
  //         <img src={SquareList} alt="Bookmark" className="w-[16px] h-[16px] mr-1" />
  //         <span>Bookmarks</span>
  //         {bookmarks.length > 0 && !isLoading.isMessageLoading && (
  //           <Badge count={bookmarks.length} className="text-white border-black" />
  //         )}
  //       </span>
  //     ),
  //     children: <Bookmarks data-testid="bookmarks" mode={mode} />
  //   },

  // ];

  return (
    <Layout className={`chat-bot-container ${mode === 'embedded' || mode === 'horizontal' ? 'embedded' : ''}`}>
      {mode == 'standalone' && !isDocumentMode && (
        <Sider width={350} className="!bg-zinc-100 rounded-t-lg rounded-bl-lg">
          <SideNavigation mode={mode} />
        </Sider>
      )}

      <Content
        className={`content ${
          mode === 'embedded' || mode === 'horizontal' ? 'embedded' : ''
        } flex items-center w-full pt-4`}
      >
        <div className={`w-full ${mode === 'standalone' ? 'max-w-[1200px]' : ''}`}>
          {currentSessionId && currentSessionId?.id && (
            <DealHeader
              currentSessionId={currentSessionId}
              dealId={currentSessionId?.project?.contractId?.toString() || ''}
              salesforceDealName={currentSessionId?.metadata?.salesforceDealName || ''}
              projectName={currentSessionId?.project?.name || ''}
              client={currentSessionId?.metadata?.client || ''}
              supplier={currentSessionId?.metadata?.vendor || ''}
              dealType={currentSessionId?.metadata?.dealType || ''}
              category={currentSessionId?.category || ''}
              type={mode}
            />
          )}
          {isDocumentMode ? <Canvas mode={mode} /> : <Conversations data-testid="conversations" mode={mode} />}
          {/* <Tabs
            activeKey={activeKey}
            data-testid="tabs"
            onChange={(key) => setActiveKey(key)}
            tabBarExtraContent={
              currentSessionId &&
              currentSessionId?.category === 'DEAL' &&
              (isMessageLoading ? (
                <div className="flex items-center space-x-2">
                  <Skeleton.Button active size="small" className="w-10 h-10 mt-1" />
                </div>
              ) : (
                <div className="flex items-center space-x-2">
                  <img
                    title="New conversation"
                    src={newConversationImage}
                    alt="new conversation"
                    onClick={() => {
                      handleNewConversation(currentSessionId?.project || undefined);
                    }}
                    className="w-10 h-10 cursor-pointer "
                  />
                  <MoreActions
                    page="chat-bot"
                    category={currentSessionId?.category || ''}
                    nodeCategory={NodeCategory.PROJECT}
                    project={currentSessionId?.project || undefined}
                    projectIndex={getProjectIndex()}
                  />
                </div>
              ))
            }
            items={items}
            className={`button-style-tabs ${mode === 'embedded' ? 'embedded' : ''}`}
          /> */}
        </div>
      </Content>
      {isDocumentMode && (
        <Sider width={450} className="!bg-white p-2">
          <div className="flex items-center justify-end m-2">
            <Button onClick={handleExitWriteMode} type="link" icon={<CloseCircleFilled />}>
              Exit Write Mode
            </Button>
          </div>
          <div className="border-l border-gray-300 border-solid rounded-lg p-2">
            <div className="flex items-center">
              <img src={juggernaut} alt="Bookmark" className="w-[40px] h-[40px] mr-2" />
              <p className="text-xl font-bold mb-0">Juggernaut</p>
            </div>
            <Conversations data-testid="conversations" mode={mode} />
          </div>
        </Sider>
      )}

      {/* Dialog component for renaming items */}
      <RenameDialog />

      {/* Dialog component for deleting items */}
      <DeleteDialog />
    </Layout>
  );
};

export default ChatBot;
